import { useEffect, useState, useRef } from 'react';

const useMVCSID = (interval = 500, maxTries = 10, isTest = false) => {
  const [mcvisid, setMcvisid] = useState('');
  const ref = useRef();

  useEffect(() => {
    let count = 0;
    let val = '';
    if (isTest) {
      val = '1706516516';
    } else {
      val = window?.cookieUtils?.readBrowserCookie('_meta_neustar_mcvisid');
    }
    if (val) {
      setMcvisid(val);
    } else {
      /* istanbul ignore next */
      ref.current = setInterval(() => {
        val = window?.cookieUtils?.readBrowserCookie('_meta_neustar_mcvisid');

        if (val) {
          clearInterval(ref.current);
          setMcvisid(val);

        } else {
          count += 1;
          if (count > maxTries) clearInterval(ref.current);
        }

      }, interval);
    }
    return () => {
      if (ref.current) clearInterval(ref.current);
    };
  }, []);

  return mcvisid;
};
export default useMVCSID;